








































import Vue from 'vue';
import { ICalendarContentDoor, ICalendarProductDoor } from '@/common/interfaces/announcement-bar.interface';
import ChristmasCalendarLink from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarLink.vue';

export default Vue.extend({
  name: `ChristmasCalendarDoorContent`,
  components: { ChristmasCalendarLink },
  computed: {
    buttonLabel(): string {
      if(this.contentDoor) {
        return (this.content as ICalendarContentDoor).buttonText ? this.$t(`announcement-bar-ufe:${(this.content as ICalendarContentDoor).buttonText}`) : ``;
      }
      if(this.multipleSaleProducts) {
        return this.$t(`announcement-bar-ufe:calendar.productDoor.goToOffers`);
      }
      return this.$t(`announcement-bar-ufe:calendar.productDoor.goToOffer`);
    },
    buttonLink(): string {
      if(this.contentDoor) {
        return (this.content as ICalendarContentDoor).link ?? ``;
      }
      if(this.multipleSaleProducts) {
        return `/angebote/`;
      }
      return (this.content as ICalendarProductDoor).products[0].link ?? ``;
    },
    contentDoor(): boolean {
      return this.content.type === `content`;
    },
    multipleSaleProducts(): boolean {
      return (this.content as ICalendarProductDoor).products?.length > 1 ?? false;
    },
    productDoor(): boolean {
      return this.content.type === `product`;
    },
    showButton(): boolean {
      return (this.contentDoor && !!(this.content as ICalendarContentDoor).link) || this.productDoor;
    },
    text(): string {
      if(this.contentDoor || this.multipleSaleProducts) {
        return this.$t(`announcement-bar-ufe:${this.content.text}`);
      }
      return (this.content as ICalendarProductDoor).products[0].description;
    },
    title(): string {
      if(this.contentDoor) {
        return (this.content as ICalendarContentDoor).title ? this.$t(`announcement-bar-ufe:${(this.content as ICalendarContentDoor).title}`) : ``;
      }
      if(this.multipleSaleProducts) {
        return this.$t(`announcement-bar-ufe:calendar.productDoor.title`);
      }
      return (this.content as ICalendarProductDoor).products[0].name;
    },
  },
  props: {
    content: {
      required: true,
      type: Object as () => ICalendarContentDoor | ICalendarProductDoor,
    },
    logoPath: {
      required: true,
      type: String,
    },
  },
});
